// extracted by mini-css-extract-plugin
module.exports = {"wallItem":"_1z0nVm","link":"vezBgN","textWrap":"fA8VQ4","title":"_1hAsl6","intro":"_3hZqvs","additionalIntro":"_3obKnp"};